























































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import PeriodSimplifier from '../../../../../PeriodSimplifier/PeriodSimplifier.vue'
import { StepUnit } from '../../../../../PeriodSimplifier/types'
import FieldTitle from '../../../../../Pi/components/FieldTitle.vue'
import { FieldData } from '../../../../../Pi/types'
import { TagData } from '../../../../../Tags/types'
import SettingsMessageManager from '../../logic/SettingsMessageManager'
import { IMessageSettings } from '../../logic/types'
import MessageSettingsDisableLinkPreview from './components/MessageSettingsDisableLinkPreview.vue'
import MessageSettingsDisableNotify from './components/MessageSettingsDisableNotify.vue'
import MessageSettingsPin from './components/MessageSettingsPin.vue'
import MessageSettingsProtectContent from './components/MessageSettingsProtectContent.vue'
import MessageSettingsRemoveAfter from './components/MessageSettingsRemoveAfter.vue'
import MessageSettingsRemovePrevious from './components/MessageSettingsRemovePrevious.vue'
import MessageSettingsSendAfter from './components/MessageSettingsSendAfter.vue'

@Component({
  components: {
    MessageSettingsProtectContent,
    MessageSettingsRemovePrevious,
    MessageSettingsDisableNotify,
    MessageSettingsDisableLinkPreview,
    MessageSettingsPin,
    FieldTitle,
    PeriodSimplifier,
    MessageSettingsRemoveAfter,
    MessageSettingsSendAfter,
  },
  data() {
    return {
      StepUnit,
    }
  }
})
export default class MessageSettings extends Vue {
  @Prop() settingsMessageManager!: SettingsMessageManager

  @Prop() options!: Record<string, any>

  @Prop() disabled!: boolean

  @Prop() havePreview!: boolean

  @Prop() settingsStructure!: Partial<IMessageSettings>

  isControlVisible(key: keyof IMessageSettings): boolean {
    if (this.settingsStructure) {
      return this.settingsStructure[key] !== undefined
    }

    return true
  }

  checkTariffTags(tariff: string): Array<TagData> | null {
    if (this.options && this.options[tariff]) {
      return this.options[tariff]
    }
    return null
  }

  inputConfig(arg: FieldData): FieldData {
    arg.setter = (val) => {
      this.$set(arg.model, arg.key as string, val)
      this.settingsMessageManager.updateMessageSettings()
    }
    return arg
  }
}
